const VISIBILITY_STORAGE_KEY = 'strategyPresetModalVisible';
const VISIBILITY_EVENT_NAME = 'strategyPresetModalVisibilityChange';

const isWindowAvailable = () => typeof window !== 'undefined';

export const getStrategyPresetModalVisibility = () => {
  if (!isWindowAvailable()) {
    return false;
  }

  return window.localStorage.getItem(VISIBILITY_STORAGE_KEY) === 'true';
};

const dispatchVisibilityChange = (visible) => {
  if (!isWindowAvailable()) {
    return;
  }

  window.localStorage.setItem(
    VISIBILITY_STORAGE_KEY,
    visible ? 'true' : 'false'
  );
  window.dispatchEvent(
    new CustomEvent(VISIBILITY_EVENT_NAME, {
      detail: { visible }
    })
  );
};

export const showStrategyPresetModal = () => {
  dispatchVisibilityChange(true);
};

export const hideStrategyPresetModal = () => {
  dispatchVisibilityChange(false);
};

export const STRATEGY_PRESET_MODAL_EVENT = VISIBILITY_EVENT_NAME;
export const STRATEGY_PRESET_MODAL_STORAGE_KEY = VISIBILITY_STORAGE_KEY;
